export default __webpack_public_path__ + "static/media/Deed of Contract - Img - Final (2)_12.01898a77.jpg";